import {
  EditDeparturesComponent,
  SpecialMarksComponent,
} from '$modules/personal/modules/batch/features/batches/modals';
import { BatchCommitedComponent } from '$modules/personal/modules/batch/features/batches/modals/batch-commited/batch-commited.component';
import { PublicationCreateComponent } from '$modules/personal/modules/publications/modals/publication-create/publication-create.component';
import { PublicationUpdateComponent } from '$modules/personal/modules/publications/modals/publication-update/publication-update.component';
import { NewVirtualPublicationComponent } from '$modules/personal/virtual-publication-uploader/new-virtual-publication/new-virtual-publication.component';
import { SharedModule } from '$shared/shared.module';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ModalModule as BsModalModule } from 'ngx-bootstrap/modal';
import { AppointmentModalComponent } from './appointment-modal/appointment-modal.component';
import { ChangeEmailComponent } from './change-email/change-email.component';
import { ChangeNameComponent } from './change-name/change-name.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ChangePhoneComponent } from './change-phone/change-phone.component';
import { ChangeRedirectPointModalComponent } from './change-redirect-point-modal/change-redirect-point-modal.component';
import { ConfirmDeleteModalComponent } from './confirm-delete/confirm-delete.component';
import { ConfirmVoteComponent } from './confirm-vote/confirm-vote.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { CustomTrackModalComponent } from './custom-track-modal/custom-track-modal.component';
import { DeleteAccountComponent } from './delete-account/delete-account.component';
import { DocumentSnapshotComponent } from './document-snapshot/document-snapshot.component';
import { DownloadButtonComponent } from './download-contracts-modal/download-btn/download-btn.component';
import { DownloadContractsComponent } from './download-contracts-modal/download-contracts-modal.component';
import { ElsInfoComponent } from './els-info/els-info.component';
import { ForgotPasswordModalComponent } from './forgot-password-modal/forgot-password-modal.component';
import { GenerateReportComponent } from './generate-report/generate-report.component';
import { GenerateSdoReportComponent } from './generate-sdo-report/generate-sdo-report.component';
import { HsCodeItemComponent } from './hs-codes-modal/hs-code-item/hs-code-item';
import { HsCodesModalComponent } from './hs-codes-modal/hs-codes-modal';
import { IdentificationWarningComponent } from './identification-warning/identification-warning.component';
import { IdentifyUserComponent } from './identify-user/identify-user.component';
import { LoginModalComponent } from './login-modal/login-modal.component';
import { ManageAddressComponent } from './manage-address/manage-address.component';
import { ManageAppealComponent } from './manage-appeal/manage-appeal.component';
import { ManageCardComponent } from './manage-card/manage-card.component';
import { ManageCargoOrderComponent } from './manage-cargo-order/manage-cargo-order.component';
import { ManageCheckingAccountComponent } from './manage-checking-account/manage-checking-account.component';
import { ManageCourierOrderComponent } from './manage-courier-order/manage-order.component';
import { ManageLegalAddressComponent } from './manage-legal-address/manage-legal-address.component';
import { ManageRecipientComponent } from './manage-recipient/manage-recipient.component';
import { MarketplaceConfirmComponent } from './marketplace-confirm/marketplace-confirm.component';
import { NewCardComponent } from './new-card/new-card.component';
import { NewCorporateCardComponent } from './new-corporate-card/new-corporate-card.component';
import { OpsSelectComponent } from './ops-select/ops-select.component';
import { ProofOfPaymentComponent } from './proof-of-payment/proof-of-payment.component';
import { RegistrationModalComponent } from './registration-modal/registration-modal.component';
import { SelectAddressComponent } from './select-address/select-address.component';
import { SelectCardComponent } from './select-card/select-card.component';
import { SelectLegalAddressComponent } from './select-legal-address/select-legal-address.component';
import { SendVoteComponent } from './send-vote/send-vote.component';
import { StepModalComponent } from './step-modal/step-modal.component';
import { ApproveSubscriptionCancellationComponent } from './subscription-orders/approve-subscription-cancellation/approve-subscription-cancellation.component';
import { ManageSubscriptionDataComponent } from './subscription-orders/manage-subscription-data/manage-subscription-data.component';
import { ManageSubscriptionDeliveryComponent } from './subscription-orders/manage-subscription-delivery/manage-subscription-delivery.component';
import { ManageSubscriptionOrderComponent } from './subscription-orders/manage-subscription-order/manage-subscription-order.component';
import { SubscriptionSelectModalComponent } from './subscription-select-modal/subscription-select-modal.component';
import { SuccessDeliveryModalComponent } from './success-delivery-modal/success-delivery-modal.component';
import { SuccessRedirectionModalComponent } from './success-redirection-modal/success-redirection-modal.component';
import { WaitingPaymentComponent } from './waiting-payment-modal/waiting-payment-modal.component';
import { SmartBoxQrCodeComponent } from './smart-box-qr-code/smart-box-qr-code.component';
import { QRCodeModule } from 'angularx-qrcode';
import { RefundPaymentModalComponent } from './refund-payment-modal/refund-payment-modal.component';
import { SuccessfulDeliveryPaymentModalComponent } from './successful-delivery-payment-modal/successful-delivery-payment-modal.component';
import { PaymentCancelledModalComponent } from './payment-cancelled-modal/payment-cancelled-modal.component';
import { QrPrintInfoComponent } from './qr-print-info/qr-print-info.component';
import { ScratchModalComponent } from './scratch-modal/scratch-modal.component';
import { AdditionalAgreementModalComponent } from '$core/modal/additional-agreement-modal/additional-agreement-modal.component';
import { ResetContactDataModalComponent } from '$core/modal/reset-contact-data-modal/reset-contact-data-modal.component';
import { ChooseAddressModalComponent } from './subscription-orders/choose-address-modal/choose-address-modal.component';
import { CheckoutComponent } from '$shared/modules/checkout';

@NgModule({
  declarations: [
    LoginModalComponent,
    RegistrationModalComponent,
    SubscriptionSelectModalComponent,
    ForgotPasswordModalComponent,
    ChangePasswordComponent,
    ChangeEmailComponent,
    ChangePhoneComponent,
    ConfirmationModalComponent,
    ManageAddressComponent,
    ManageAppealComponent,
    ManageCourierOrderComponent,
    ManageSubscriptionOrderComponent,
    ChangeNameComponent,
    SelectAddressComponent,
    SelectCardComponent,
    ManageLegalAddressComponent,
    SelectLegalAddressComponent,
    ManageSubscriptionDataComponent,
    ManageSubscriptionDeliveryComponent,
    WaitingPaymentComponent,
    ProofOfPaymentComponent,
    ApproveSubscriptionCancellationComponent,
    ManageCardComponent,
    NewCardComponent,
    OpsSelectComponent,
    NewVirtualPublicationComponent,
    NewCorporateCardComponent,
    SendVoteComponent,
    ConfirmVoteComponent,
    ManageCargoOrderComponent,
    ElsInfoComponent,
    GenerateReportComponent,
    GenerateSdoReportComponent,
    SuccessDeliveryModalComponent,
    DeleteAccountComponent,
    ManageCheckingAccountComponent,
    ChangeRedirectPointModalComponent,
    SuccessRedirectionModalComponent,
    IdentificationWarningComponent,
    HsCodesModalComponent,
    HsCodeItemComponent,
    StepModalComponent,
    DownloadContractsComponent,
    DownloadButtonComponent,
    AppointmentModalComponent,
    DocumentSnapshotComponent,
    ConfirmDeleteModalComponent,
    EditDeparturesComponent,
    ManageRecipientComponent,
    SpecialMarksComponent,
    BatchCommitedComponent,
    MarketplaceConfirmComponent,
    CustomTrackModalComponent,
    PublicationCreateComponent,
    PublicationUpdateComponent,
    IdentifyUserComponent,
    SmartBoxQrCodeComponent,
    RefundPaymentModalComponent,
    SuccessfulDeliveryPaymentModalComponent,
    PaymentCancelledModalComponent,
    QrPrintInfoComponent,
    ScratchModalComponent,
    AdditionalAgreementModalComponent,
    ResetContactDataModalComponent,
    ChooseAddressModalComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    BsModalModule.forRoot(),
    QRCodeModule,
    CheckoutComponent,
  ],
  exports: [BsModalModule, SpecialMarksComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ModalModule {}
